import React from 'react';
import { motion } from 'framer-motion';
import { CalendarIcon, ZapIcon, RefreshCwIcon, ShieldCheckIcon } from 'lucide-react';
export function TreatmentFrequency() {
  const cards = [{
    icon: ZapIcon,
    title: 'Newer / Acute Issues',
    desc: 'Some newer injuries or flare-ups may respond in a shorter series.'
  }, {
    icon: RefreshCwIcon,
    title: 'Chronic / Recurring Pain',
    desc: 'Long-standing pain or inflammation may require a longer plan.'
  }, {
    icon: ShieldCheckIcon,
    title: 'Maintenance / Flare-Up Support',
    desc: 'Some patients use laser therapy periodically when appropriate.'
  }];
  return <section className="py-16 md:py-20 bg-brand-gray-light" data-id="element-258">
      <div className="w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-259">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center max-w-3xl mx-auto mb-10" data-id="element-260">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-brand-navy mb-4 leading-tight" data-id="element-261">
            How Many Treatments Are Usually Recommended?
          </h2>
          <p className="text-base md:text-lg text-gray-700 leading-relaxed" data-id="element-262">
            Laser therapy is usually not a one-and-done service. Paragon
            Chiropractic will recommend a plan after evaluating the area,
            severity, and goals.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-10" data-id="element-263">
          {cards.map((card, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className="bg-white rounded-2xl p-6 md:p-7 border-2 border-gray-200 hover:border-brand-teal/40 hover:shadow-md transition-all duration-300 flex flex-col" data-id="element-264">
              <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-4 bg-brand-teal text-white shadow-md shadow-brand-teal/20" data-id="element-265">
                <card.icon className="w-6 h-6" data-id="element-266" />
              </div>
              <h3 className="text-lg md:text-xl font-black mb-2 leading-tight text-brand-navy" data-id="element-267">
                {card.title}
              </h3>
              <p className="text-sm md:text-base leading-relaxed text-gray-700" data-id="element-268">
                {card.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="bg-brand-navy p-6 md:p-7 rounded-2xl shadow-lg max-w-3xl mx-auto flex flex-col md:flex-row items-center justify-between gap-5" data-id="element-269">
          <div className="text-center md:text-left" data-id="element-270">
            <p className="text-white font-black text-lg md:text-xl mb-1 leading-tight" data-id="element-271">
              Ask About the New Patient Intro Offer
            </p>
            <p className="text-teal-100 text-sm" data-id="element-272">
              Package options and first-session intro special available.
            </p>
          </div>
          <a href="#consultation-form" className="w-full md:w-auto flex-shrink-0 inline-flex px-6 py-3 bg-brand-teal hover:bg-brand-teal-dark text-white rounded-lg font-bold text-sm md:text-base transition-all duration-300 items-center justify-center gap-2 shadow-lg shadow-brand-teal/30" data-id="element-273">
            <CalendarIcon className="w-5 h-5" data-id="element-274" />
            Ask About the Intro Offer
          </a>
        </motion.div>
      </div>
    </section>;
}